import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthStore from "../../stores/AuthStore";
import { getParamFromUrlSearch } from "../../utils/paramsUtil";

const SSOPassPage: React.FC = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthStore.ssoIsLogin) {
      const params = getParamFromUrlSearch<{ appkey?: string }>(
        document.location.search
      );
      params.appkey
        ? AuthStore.linkToSubsystem(params.appkey)
        : navigate("/admin");
    } else {
      navigate("/sso/login");
    }
  }, []);

  return <div></div>;
};

export default SSOPassPage;
